<div class="row">
  <ng-container *ngFor="let input of inputs; let i = index">
    <div [ngClass]="getColClass(input)" *ngIf="
        !(
          activityName === 'Mis' &&
          (input.labelName === 'Prodotti Presentati' || input.labelName === 'Medici' || input.labelName === 'Saggi Consegnati')
        ) && !(input.labelName === 'Data Fine' && !showDataFineField)
      " class="mb-3">
      <!-- Input normale -->
      <div *ngIf="!isArray(input) && input.inputType === 'input' && input.labelName !== 'productDoctor'"
        class="form-group">
        <label class="form-label" [for]="input.labelName">
          {{ input.labelName }}
          <sup *ngIf="input.mandatory && mode !== 'visualizza'">*</sup>
        </label>
        <input (input)="onInputChange($event, i, 'input')" class="form-control" [id]="input.name || input.labelName"
          [value]="input.value ? input.value : ''" [type]="input.dataType == 'Int' ? 'number' : 'text'"
          [readOnly]="mode === 'visualizza' || input.readOnly" />
        <div class="text-danger mt-1" *ngIf="input.mandatory && isInvalid[i] && showValidationErrors">
          <div>Campo obbligatorio</div>
        </div>
      </div>

      <!-- Textarea -->
      <div
        *ngIf="!isArray(input) && (input.inputType === InputType.TEXTAREA || input.inputType === InputType.TEXT_AREA)"
        class="form-group">
        <label class="form-label" [for]="input.labelName">
          {{ input.labelName }}
          <sup *ngIf="input.mandatory && mode !== 'visualizza'">*</sup>
        </label>
        <textarea (input)="onInputChange($event, i, 'textarea')" class="form-control" rows="3"
          [value]="input.value ? input.value : ''" [readOnly]="mode === 'visualizza' || input.readOnly"></textarea>
        <div class="text-danger mt-1" *ngIf="input.mandatory && isInvalid[i] && showValidationErrors">
          <div>Campo obbligatorio</div>
        </div>
      </div>

      <!-- MultiRow -->
      <div
        *ngIf="!isArray(input) && input.inputType === 'select' && input.multiRow && input.multiRowData && input.multiRowData.length > 0"
        class="form-group">
        <label class="form-label">
          {{ input.labelName }}
          <sup *ngIf="input.mandatory && mode !== 'visualizza'">*</sup>
        </label>
        <div *ngFor="let item of input.multiRowData; let j = index"
          class="form-group d-flex align-items-center justify-content-between gap-2 mb-3">
          <div [style]="{ width: item.quantityField ? '60%' : '85%' }">
            <ng-select [items]="input.data || []" [searchable]="true" [ngModel]="item.value"
              [multiple]="item.multiSelect" [closeOnSelect]="item.multiSelect ? false : true"
              [bindLabel]="input.bindedLabel ? input.bindedLabel : 'description'" bindValue="id" class="selectResearch"
              [ngClass]="{ 'single-control': !item.multiSelect }"
              (ngModelChange)="onInputChange($event, i, 'select', j)" [disabled]="mode === 'visualizza'"></ng-select>
          </div>
          <div style="width: 30%" *ngIf="item.quantityField">
            <label class="form-label">Quantità</label>
            <div class="d-flex align-items-center justify-content-between gap-1">
              <button *ngIf="mode !== 'visualizza'" class="btn small-square-primary button-add-object" type="button"
                (click)="item.quantity = item.quantity > 0 ? item.quantity - 1 : 0">
                <img style="height: auto; width: 20px; filter: invert()"
                  src="../../../../assets/svg/toggle-row-minus.svg" alt="Meno" />
              </button>
              <input (input)="onInputChange($event, i, 'quantity', j)" (blur)="onQuantityBlur(i, j)"
                class="form-control" [value]="item.quantity" type="number" [disabled]="mode === 'visualizza'" />
              <button *ngIf="mode !== 'visualizza'" class="btn small-square-primary button-add-object" type="button"
                (click)="item.quantity = item.quantity + 1">
                <img style="height: auto; width: 20px; filter: invert()"
                  src="../../../../assets/svg/toggle-row-plus.svg" alt="Aggiungi" />
              </button>
            </div>
          </div>
          <div style="width: 10%" class="d-flex gap-1">
            <button *ngIf="j > 0 && mode !== 'visualizza'" class="btn btn-small-plus small-delete-icon" type="button"
              (click)="removeRow(i, j)" title="Elimina riga">
              <img src="../../../../assets/svg/trash-icon.svg" alt="Elimina" />
            </button>
            <button *ngIf="input.multiRowData && input.multiRowData.length === j + 1 && mode !== 'visualizza'"
              class="btn btn-small-plus small-delete-icon" type="button" (click)="addRow(i)" title="Aggiungi riga">
              <img src="../../../../assets/svg/small-plus-icon.svg" alt="Aggiungi" />
            </button>
          </div>
        </div>
      </div>

      <!-- Select base -->
      <div *ngIf="!isArray(input) && input.inputType === 'select' && !input.multiRow" class="form-group">
        <label class="form-label" [for]="input.labelName">
          {{ input.labelName }}
          <sup *ngIf="input.mandatory && mode !== 'visualizza'">*</sup>
        </label>
        <ng-select [items]="input.data || []" [ngModel]="input.value" [multiple]="input.multiSelect"
          [closeOnSelect]="input.multiSelect ? false : true"
          [bindLabel]="input.bindedLabel ? input.bindedLabel : 'description'" bindValue="id" class="selectResearch"
          [ngClass]="{ 'single-control': !input.multiSelect }" (ngModelChange)="onInputChange($event, i, 'select')"
          [disabled]="mode === 'visualizza' || (input.readOnly ?? false)"></ng-select>
        <div class="text-danger mt-1" *ngIf="input.mandatory && isInvalid[i] && showValidationErrors">
          <div>Campo obbligatorio</div>
        </div>
      </div>

      <!-- Date -->
      <div *ngIf="!isArray(input) && input.inputType === 'date'" class="form-group">
        <label class="form-label" [for]="input.labelName">
          {{ input.labelName }}
          <sup *ngIf="input.mandatory && mode !== 'visualizza'">*</sup>
        </label>
        <input class="datepicker-here form-control digits" placeholder="gg-mm-aaaa"
          [value]="input.name ? formattedDates[input.name] : ''" name="dp" ngbDatepicker container="body"
          #d="ngbDatepicker" [markDisabled]="isDisabled" (click)="d.toggle()"
          (dateSelect)="onInputChange($event, i, 'date')" (input)="onInputChange($event, i, 'date')"
          [disabled]="mode === 'visualizza' || (input.readOnly ?? false)" />
        <div class="text-danger mt-1" *ngIf="input.mandatory && isInvalid[i] && showValidationErrors">
          {{ input.errorMessage ? input.errorMessage : input.mandatory && isInvalid[i] ? 'Campo obbligatorio' : 'Campo
          non valido' }}
        </div>
      </div>

      <!-- Checkbox -->
      <div *ngIf="!isArray(input) && input.inputType === 'checkbox'" class="form-group">
        <label class="form-label" [for]="input.labelName">
          {{ input.labelName }}
          <sup *ngIf="input.mandatory && mode !== 'visualizza'">*</sup>
        </label>
        <div class="checkbox m-squar">
          <input [id]="input.name || input.labelName" type="checkbox" [checked]="input.value ? true : false"
            [value]="input.value ? true : false" (change)="onInputChange($event, i, 'checkbox')"
            [disabled]="mode === 'visualizza'" />
          <span class="checkmark"></span>
        </div>
        <div class="text-danger mt-1" *ngIf="input.mandatory && isInvalid[i] && showValidationErrors">
          <div>Campo obbligatorio</div>
        </div>
      </div>

      <!-- Checklist -->
      <div *ngIf="!isArray(input) && input.inputType === 'checklist'" class="form-group">
        <label class="form-label" [for]="input.labelName">
          {{ input.labelName }}
          <sup *ngIf="input.mandatory && mode !== 'visualizza'">*</sup>
        </label>
        <div class="checklist-container">
          <div *ngFor="let item of input.data" class="form-check">
            <input type="checkbox" class="form-check-input" [id]="item.id" [value]="item"
              [checked]="presentedProductsIds.includes(item)" (change)="onInputChange($event, i, 'checklist')"
              [disabled]="mode === 'visualizza'" />
            <label class="form-check-label" [for]="item.id">
              {{ item[input.bindedLabel || 'name'] }}
            </label>
          </div>
        </div>
        <div class="text-danger mt-1" *ngIf="input.mandatory && isInvalid[i] && showValidationErrors">
          <div>Campo obbligatorio</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Gestione MIS -->
<div *ngIf="activityName === 'Mis' && showMisForm" class="col-12 mt-3">
  <!-- Prodotti Presentati -->
  <div class="mb-4">
    <label class="form-label">Prodotti Presentati</label>
    <ul class="checklist-container">
      <li *ngFor="let item of misProducts; let i = index">
        <div class="d-flex align-items-center gap-2 mb-2">
          <div class="checkbox m-squar">
            <input [id]="item?.id" type="checkbox" [disabled]="mode === 'visualizza'"
              [checked]="isMisProdottoSelezionato(item)" (change)="onMisProdottoToggle(item, $event)" />
            <span class="checkmark"></span>
          </div>
          <span>{{ item.variant?.name }}</span>
        </div>
      </li>
    </ul>
  </div>

  <!-- Medici multipli e saggi consegnati -->
  <div class="mb-3">
    <label class="form-label fw-bold">Medici partecipanti</label>
    <ng-select [items]="filteredDoctors" bindLabel="fullName" bindValue="id" [(ngModel)]="selectedDoctors"
      [multiple]="true" [searchable]="false" [clearable]="true" [clearSearchOnAdd]="false"
      placeholder="Seleziona medici" style="width: 400px" [disabled]="mode === 'visualizza'"
      (open)="resetFilteredDoctors()" (ngModelChange)="onParticipatingDoctorsChange($event)">
      <ng-template ng-option-tmp let-item="item">
        {{ item.fullName }}
      </ng-template>

      <ng-template ng-header-tmp>
        <input type="text" class="form-control" placeholder="Cerca medico..."
          (keydown.backspace)="onSearchBackspace($event)" (input)="onDoctorSearch($event)"
          [disabled]="mode === 'visualizza'" />
      </ng-template>
    </ng-select>
  </div>

  <!-- Sezioni per ogni medico e saggi -->
  <div *ngFor="let row of misDoctorsRows; let rowIndex = index" class="mb-4">
    <div class="d-flex align-items-center gap-2">
      <label class="form-label">Medici che hanno ricevuto un saggio</label>
    </div>

    <div class="d-flex align-items-center gap-2">
      <ng-select [items]="filteredDoctorsPerRow[rowIndex]" bindLabel="fullName" bindValue="id"
        [(ngModel)]="row.doctorIds" [multiple]="true" [searchable]="true" [clearable]="true"
        placeholder="Cerca e seleziona medici" (ngModelChange)="onMisMedicoSelect(rowIndex, $event)"
        (open)="resetFilteredDoctorsForRow(rowIndex)" class="custom-ngselect" style="width: 300px"
        [disabled]="mode === 'visualizza'">
        <ng-template ng-option-tmp let-item="item">
          {{ item.fullName }}
        </ng-template>

        <ng-template ng-header-tmp>
          <input type="text" class="form-control" placeholder="Cerca medico..."
            (keydown.backspace)="onSearchBackspaceForRow($event, rowIndex)"
            (input)="onDoctorSearchForRowWrapper($event, rowIndex)" [disabled]="mode === 'visualizza'" />
        </ng-template>
      </ng-select>
    </div>

    <div *ngFor="let medicoId of row.doctorIds" class="mt-2 d-flex flex-column">
      <label class="form-label fw-bold">Saggi consegnati – {{ getMisMedicoName(medicoId) }}</label>

      <div *ngFor="let saggioRow of misDoctorsEssaysSelected[medicoId]; let i = index"
        class="d-flex align-items-center gap-2 mb-2">
        <ng-select [items]="misDoctorsEssaysUnique" bindLabel="name" bindValue="id" [(ngModel)]="saggioRow.saggioId"
          [searchable]="true" placeholder="Seleziona saggio" (ngModelChange)="updateMisSaggio([medicoId], i, $event)"
          [disabled]="saggioRow.locked || mode === 'visualizza'" style="width: auto; min-width: 300px"
          class="custom-ngselect">
          <ng-template ng-option-tmp let-item="item">
            {{ item?.name }}
          </ng-template>

          <ng-template ng-header-tmp>
            <input type="text" class="form-control" placeholder="Cerca saggio..."
              (input)="onSaggioFilter(medicoId, i, $event)" [disabled]="mode === 'visualizza'" />
          </ng-template>
        </ng-select>

        <button *ngIf="mode !== 'visualizza'" class="btn small-square-primary button-add-object" type="button"
          (click)="saggioRow.quantita = (saggioRow.quantita || 0) > 0 ? (saggioRow.quantita || 0) - 1 : 0; updateMisQuantita([medicoId], i, saggioRow.quantita)">
          <img style="height: auto; width: 20px; filter: invert()" src="../../../../assets/svg/toggle-row-minus.svg"
            alt="Meno" />
        </button>

        <input type="number" class="form-control" style="width: 90px" min="1" [ngModel]="saggioRow.quantita"
          (ngModelChange)="updateMisQuantita([medicoId], i, $event)" (blur)="onMisQuantitaBlur(medicoId, i)"
          placeholder="Quantità" [disabled]="mode === 'visualizza'" />

        <button *ngIf="mode !== 'visualizza'" class="btn small-square-primary button-add-object" type="button"
          (click)="saggioRow.quantita = (saggioRow.quantita || 0) + 1; updateMisQuantita([medicoId], i, saggioRow.quantita)">
          <img style="height: auto; width: 20px; filter: invert()" src="../../../../assets/svg/toggle-row-plus.svg"
            alt="Aggiungi" />
        </button>

        <button type="button" class="btn btn-small-plus small-delete-icon" (click)="removeMisSaggioRow(medicoId, i)"
          *ngIf="mode !== 'visualizza' && !saggioRow.locked && misDoctorsEssaysSelected[medicoId].length > 1">
          <img src="../../../../assets/svg/trash-icon.svg" alt="Elimina" />
        </button>
      </div>

      <button type="button" class="btn btn-outline-primary btn-sm mt-1 btn-hover-effect"
        (click)="addMisSaggioRow(medicoId)" *ngIf="mode !== 'visualizza'">
        Aggiungi saggio
      </button>

      <hr />
    </div>

    <hr class="my-3" />
  </div>
</div>

<!-- Gestione MultiGroup -->
<div *ngIf="multiGroupData && multiGroupData.length > 0" class="col-12">
  <div class="multigroup-container">
    <div *ngFor="let group of multiGroupData; let groupIndex = index" class="multigroup-row">
      <div class="row align-items-center mt-3">
        <div *ngFor="let groupInput of group; let inputIndex = index" [ngClass]="{
            'col-5': groupInput.inputType === 'select',
            'col-2': groupInput.inputType !== 'select' && groupInput.inputType !== 'checkbox',
            'col-1 form-checkbox': groupInput.inputType === 'checkbox',
          }" class="form-group">
          <!-- Input Base MultiGroup -->
          <div *ngIf="groupInput.inputType === 'input'" class="form-group">
            <label class="form-label" [for]="groupInput.labelName">
              {{ groupInput.labelName }}
              <sup *ngIf="groupInput.mandatory && mode !== 'visualizza'">*</sup>
            </label>
            <input (input)="onInputMultiGroupChange($event, groupIndex, inputIndex, 'input')" class="form-control"
              [id]="groupInput.id" [value]="groupInput.value ? groupInput.value : ''"
              [type]="groupInput.dataType == 'Int' ? 'number' : 'text'"
              [disabled]="mode === 'visualizza' || groupInput.readOnly" />
            <div class="text-danger mt-1" *ngIf="groupInput.mandatory && isInvalid[inputIndex] && showValidationErrors">
              <div>Campo obbligatorio</div>
            </div>
          </div>

          <!-- Textarea MultiGroup -->
          <div *ngIf="groupInput.inputType === 'textarea'" class="form-group">
            <label class="form-label" [for]="groupInput.labelName">
              {{ groupInput.labelName }}
              <sup *ngIf="groupInput.mandatory && mode !== 'visualizza'">*</sup>
            </label>
            <textarea (input)="onInputMultiGroupChange($event, groupIndex, inputIndex, 'textarea')" class="form-control"
              rows="3" [value]="groupInput.value ? groupInput.value : ''"
              [disabled]="mode === 'visualizza' || groupInput.readOnly"></textarea>
            <div class="text-danger mt-1" *ngIf="groupInput.mandatory && isInvalid[inputIndex] && showValidationErrors">
              <div>Campo obbligatorio</div>
            </div>
          </div>

          <!-- Select MultiGroup -->
          <div *ngIf="groupInput.inputType === 'select'" class="form-group">
            <div class="d-flex align-items-center gap-2">
              <div [style]="{ width: groupInput.quantityField ? '70%' : '100%' }">
                <label class="form-label" [for]="groupInput.labelName"
                  *ngIf="groupInput.labelName !== 'Prodotti Consegnati' || groupIndex === 0">
                  {{ groupInput.labelName }}
                  <sup *ngIf="groupInput.mandatory && mode !== 'visualizza'">*</sup>
                </label>
                <ng-select [items]="groupInput.data" [searchable]="true" [ngModel]="groupInput.value"
                  [multiple]="groupInput.multiSelect" [closeOnSelect]="groupInput.multiSelect ? false : true"
                  [bindLabel]="groupInput.bindedLabel ? groupInput.bindedLabel : 'description'" bindValue="id"
                  class="selectResearch"
                  [ngClass]="{ 'single-control': !groupInput.multiSelect, 'understock-selected': isUnderstockSelected(groupInput) }"
                  (ngModelChange)="onInputMultiGroupChange($event, groupIndex, inputIndex, 'select')"
                  (open)="onSearch($event)" (close)="onSearch($event)"
                  [disabled]="mode === 'visualizza' || groupInput.readOnly">
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="option-item" [ngClass]="{
                        understock: item.underStock === true,
                      }">
                      {{ item.name }}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <div *ngIf="groupInput.quantityField" style="width: 30%">
                <label class="form-label"
                  *ngIf="groupInput.labelName !== 'Prodotti Consegnati' || groupIndex === 0">Quantità</label>
                <div class="d-flex align-items-center gap-1">
                  <button *ngIf="mode !== 'visualizza'" class="btn small-square-primary button-add-object" type="button"
                    (click)="
                      groupInput.quantity = groupInput.quantity > 0 ? groupInput.quantity - 1 : 0;
                      onInputMultiGroupChange(groupInput.quantity, groupIndex, inputIndex, 'quantity')
                    ">
                    <img style="height: auto; width: 20px; filter: invert()"
                      src="../../../../assets/svg/toggle-row-minus.svg" alt="Meno" />
                  </button>
                  <input (input)="onInputMultiGroupChange($event, groupIndex, inputIndex, 'quantity')"
                    (blur)="onMultiGroupQuantityBlur(groupIndex, inputIndex)" class="form-control"
                    [value]="groupInput.quantity" type="number"
                    [disabled]="mode === 'visualizza' || groupInput.readOnly" />
                  <button *ngIf="mode !== 'visualizza'" class="btn small-square-primary button-add-object" type="button"
                    (click)="
                      groupInput.quantity = groupInput.quantity + 1; onInputMultiGroupChange(groupInput.quantity, groupIndex, inputIndex, 'quantity')
                    ">
                    <img style="height: auto; width: 20px; filter: invert()"
                      src="../../../../assets/svg/toggle-row-plus.svg" alt="Aggiungi" />
                  </button>
                </div>
              </div>
            </div>
            <div class="text-danger mt-1" *ngIf="groupInput.mandatory && isInvalid[inputIndex] && showValidationErrors">
              <div>Campo obbligatorio</div>
            </div>
          </div>

          <!-- Checkbox MultiGroup -->
          <div *ngIf="groupInput.inputType === 'checkbox'" class="form-group form-checkbox">
            <label class="form-label" [for]="groupInput.labelName" *ngIf="
                (groupInput.labelName !== 'Intervista' && groupInput.labelName !== 'Flash' && groupInput.labelName !== 'Gadget') || groupIndex === 0
              ">
              {{ groupInput.labelName }}
              <sup *ngIf="groupInput.mandatory && mode !== 'visualizza'">*</sup>
            </label>
            <div class="checkbox m-squar">
              <input [id]="groupInput.id" type="checkbox" [checked]="groupInput?.value ? true : false"
                [value]="groupInput?.value ? true : false"
                (change)="onInputMultiGroupChange($event, groupIndex, inputIndex, 'checkbox')"
                [disabled]="mode === 'visualizza'" />
              <span class="checkmark"></span>
            </div>
            <div class="text-danger mt-1" *ngIf="groupInput.mandatory && isInvalid[inputIndex] && showValidationErrors">
              <div>Campo obbligatorio</div>
            </div>
          </div>

          <!-- Date MultiGroup -->
          <div *ngIf="groupInput.inputType === 'date'" class="form-group">
            <label class="form-label" [for]="groupInput.labelName">
              {{ groupInput.labelName }}
              <sup *ngIf="groupInput.mandatory && mode !== 'visualizza'">*</sup>
            </label>
            <input class="datepicker-here form-control digits" placeholder="gg-mm-aaaa"
              [value]="groupInput.formattedDate" name="dp" ngbDatepicker container="body" #d="ngbDatepicker"
              [markDisabled]="isDisabled" (click)="d.toggle()"
              (dateSelect)="onInputMultiGroupChange($event, groupIndex, inputIndex, 'date')"
              (input)="onInputMultiGroupChange($event, groupIndex, inputIndex, 'date')"
              [disabled]="mode === 'visualizza' || (groupInput.readOnly ?? false)" />
            <div class="text-danger mt-1" *ngIf="groupInput.mandatory && isInvalid[inputIndex] && showValidationErrors">
              <div>Campo obbligatorio</div>
            </div>
          </div>
        </div>

        <!-- Azioni MultiGroup -->
        <div class="col-1 d-flex gap-1">
          <button *ngIf="groupIndex > 0 && mode !== 'visualizza'" class="btn btn-small-plus small-delete-icon"
            type="button" (click)="removeMultiGroupRow(groupIndex)" title="Elimina gruppo">
            <img src="../../../../assets/svg/trash-icon.svg" alt="Elimina" />
          </button>
          <button *ngIf="multiGroupData.length === groupIndex + 1 && mode !== 'visualizza'"
            class="btn btn-small-plus small-delete-icon" type="button" (click)="addMultiGroupRow()"
            title="Aggiungi gruppo">
            <img src="../../../../assets/svg/small-plus-icon.svg" alt="Aggiungi" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Visualizzazione MultiGroup in modalità visualizza -->
<div *ngIf="mode === 'visualizza' && multiGroupDataToShow.length > 0" class="mt-4">
  <div *ngFor="let group of multiGroupDataToShow; let groupIndex = index" class="multigroup-display">
    <h6>Gruppo {{ groupIndex + 1 }}</h6>
    <div class="row">
      <div *ngFor="let item of group" class="col-4">
        <div class="form-group">
          <label class="form-label">{{ item.labelName }}</label>
          <div class="form-control-plaintext">
            <span *ngIf="returnType(item.value) === 'boolean'">
              {{ item.value ? 'Sì' : 'No' }}
            </span>
            <span *ngIf="returnType(item.value) !== 'boolean'">
              {{ item.value }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Prodotti Presentati (per attività Mis) -->
<div *ngIf="isPresentedProducts && presentedProducts.length > 0" class="mt-4">
  <h5>Prodotti Presentati</h5>
  <div class="row">
    <div *ngFor="let product of presentedProducts; let productIndex = index" class="col-12">
      <div class="form-group d-flex align-items-center gap-2">
        <div class="col-6">
          <label class="form-label">Prodotto</label>
          <input class="form-control" [value]="product.name || ''" [disabled]="true" />
        </div>
        <div class="col-2">
          <label class="form-label">Quantità</label>
          <input (input)="product.quantity = $any($event.target).value === '' ? null : +$any($event.target).value"
            (blur)="onPresentedProductQuantityBlur(productIndex)" class="form-control" [value]="product.quantity"
            type="number" [disabled]="mode === 'visualizza'" />
        </div>
        <div class="col-2">
          <button *ngIf="mode !== 'visualizza'" class="btn btn-small-plus small-delete-icon" type="button"
            (click)="presentedProducts.splice(productIndex, 1)" title="Rimuovi prodotto">
            <img src="../../../../assets/svg/trash-icon.svg" alt="Rimuovi" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>